export type RouteId = string | number;

export const appRoutes = {
  dashboard: {
    home: () => ['/dashboard'],
  },
  clients: {
    list: () => ['/comercial', 'clientes'],
    new: () => ['/comercial', 'clientes', 'novo'],
    edit: (id: RouteId) => ['/comercial', 'clientes', String(id), 'editar'],
    newTaxIssuer: (id: RouteId) => ['/comercial', 'clientes', String(id), 'emissores-fiscais', 'novo'],
    editTaxIssuer: (id: RouteId, taxInfoId: RouteId) => ['/comercial', 'clientes', String(id), 'emissores-fiscais', String(taxInfoId), 'editar'],
    details: (id: RouteId) => ['/comercial', 'clientes', String(id), 'detalhes'],
    bankAccounts: (id: RouteId) => ['/comercial', 'clientes', String(id), 'contas-bancarias'],
  },
  banks: {
    list: () => ['/comercial', 'bancos'],
  },
  customerRegistry: {
    list: () => ['/comercial', 'cadastros-de-clientes'],
  },
  representatives: {
    list: () => ['/comercial', 'representantes'],
    new: () => ['/comercial', 'representantes', 'novo'],
    edit: (id: RouteId) => ['/comercial', 'representantes', String(id), 'editar'],
  },
  orders: {
    list: () => ['/comercial', 'gestao-de-pedidos'],
    details: (id: RouteId) => ['/comercial', 'gestao-de-pedidos', String(id), 'detalhes'],
    new: () => ['/comercial', 'gestao-de-pedidos', 'novo'],
    edit: (id: RouteId) => ['/comercial', 'gestao-de-pedidos', String(id), 'editar'],
  },
  eventGroups: {
    list: () => ['/operacional', 'grupos-de-eventos'],
    new: () => ['/operacional', 'grupos-de-eventos', 'novo'],
    edit: (id: RouteId) => ['/operacional', 'grupos-de-eventos', String(id), 'editar'],
    dashboard: (id: RouteId) => ['/operacional', 'grupos-de-eventos', String(id), 'dashboard'],
  },
  events: {
    list: () => ['/operacional', 'eventos'],
    new: () => ['/operacional', 'eventos', 'novo'],
    edit: (id: RouteId) => ['/operacional', 'eventos', String(id), 'editar'],
    editSubEvent: (id: RouteId) => ['/operacional', 'eventos', String(id), 'editar-subevento'],
    dashboard: (id: RouteId) => ['/operacional', 'eventos', String(id), 'dashboard'],
    tickets: (id: RouteId) => ['/operacional', 'eventos', String(id), 'ingressos'],
    consumption: (id: RouteId, integrationId: RouteId) => ['/operacional', 'eventos', String(id), 'integracao', String(integrationId), 'consumacao'],
    ticketInfo: (id: RouteId, integrationId: RouteId) => ['/operacional', 'eventos', String(id), 'ingressos', 'informacoes', String(integrationId)],
    ticketTechnicians: (id: RouteId, posId: RouteId) => ['/operacional', 'eventos', String(id), 'ingressos', 'tecnicos', String(posId)],
    ticketPayments: (id: RouteId, posId: RouteId) => ['/operacional', 'eventos', String(id), 'ingressos', 'pagamentos', String(posId)],
    ticketLinked: (id: RouteId, posId: RouteId) => ['/operacional', 'eventos', String(id), 'ingressos', 'vinculados', String(posId)],
    integrationDevices: (eventid: RouteId, id: RouteId) => ['/operacional', 'eventos', String(eventid), 'integracao', 'dispositivos', String(id)],
    integrationDashboard: (eventid: RouteId) => ['/operacional', 'eventos', String(eventid), 'integracao', 'dashboard'],
    stock: (eventId: RouteId) => ['/operacional', 'eventos', String(eventId), 'estoque'],
    tables: (eventId: RouteId) => ['/operacional', 'eventos', String(eventId), 'gestao-de-mesas'],
  },
  technicians: {
    list: () => ['/operacional', 'tecnicos'],
  },
  productCategories: {
    list: () => ['/operacional', 'categorias-de-produtos'],
  },
  products: {
    list: () => ['/operacional', 'produtos'],
    new: () => ['/operacional', 'produtos', 'novo'],
    edit: (id: RouteId) => ['/operacional', 'produtos', String(id), 'editar'],
    duplicate: (id: RouteId) => ['/operacional', 'produtos', String(id), 'duplicar'],
  },
  printers: {
    list: () => ['/operacional', 'impressoras'],
  },
  additionalItems: {
    list: () => ['/operacional', 'adicionais-de-produto'],
  },
  salePoints: {
    list: () => ['/operacional', 'pontos-de-venda'],
  },
  paymentTypes: {
    list: () => ['/operacional', 'formas-de-pagamento'],
  },
  devices: {
    list: () => ['/operacional', 'dispositivos'],
  },
  appPermissions: {
    list: () => ['/operacional', 'permissoes-do-app'],
    new: () => ['/operacional', 'permissoes-do-app', 'novo'],
    edit: (id: RouteId) => ['/operacional', 'permissoes-do-app', String(id), 'editar'],
  },
  ncms: {
    list: () => ['/operacional', 'ncm'],
  },
  benefits: {
    new: (eventId: RouteId) => ['/operacional', 'eventos', String(eventId), 'beneficios', 'novo'],
    edit: (eventId: RouteId, benefitId: RouteId) => ['/operacional', 'eventos', String(eventId), 'beneficios', String(benefitId), 'editar'],
    dashboard: (eventId: RouteId, benefitId: RouteId) => ['/operacional', 'eventos', String(eventId), 'beneficios', String(benefitId), 'dashboard'],
  },
  permissions: {
    list: () => ['/administrativo', 'permissoes'],
    new: () => ['/administrativo', 'permissoes', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'permissoes', String(id), 'editar'],
  },
  users: {
    list: () => ['/administrativo', 'usuarios'],
    new: () => ['/administrativo', 'usuarios', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'usuarios', String(id), 'editar'],
  },
  pendencies: {
    list: () => ['/administrativo', 'pendencias'],
    new: () => ['/administrativo', 'pendencias', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'pendencias', String(id), 'editar'],
  },
  notifications: {
    list: () => ['/administrativo', 'notificacoes'],
    new: () => ['/administrativo', 'notificacoes', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'notificacoes', String(id), 'editar'],
  },
  organizations: {
    list: () => ['/administrativo', 'organizacoes'],
    new: () => ['/administrativo', 'organizacoes', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'organizacoes', String(id), 'editar'],
  },
  apiAccess: {
    list: () => ['/administrativo', 'acessos-api'],
    new: () => ['/administrativo', 'acessos-api', 'novo'],
    edit: (id: RouteId) => ['/administrativo', 'acessos-api', String(id), 'editar'],
  },
  partners: {
    list: () => ['/administrativo', 'parceiros'],
    new: () => ['/administrativo', 'parceiros', 'novo'],
  },
  fees: {
    list: () => ['/financeiro', 'taxas'],
  },
  acquirerRates: {
    list: () => ['/financeiro', 'taxas-do-adquirente'],
  },
  reconciliations: {
    list: () => ['/financeiro', 'conciliacao'],
  },
  closures: {
    list: () => ['/financeiro', 'fechamentos'],
    search: () => ['/financeiro', 'fechamentos', 'consulta'],
  },
  costs: {
    list: (event_closing_id: RouteId) => ['/financeiro', 'custos', String(event_closing_id)],
  },
  creditAdjustments: {
    list: (event_closing_id: RouteId) => ['/financeiro', 'ajuste-de-credito', String(event_closing_id)],
  },
  taxControl: {
    list: () => ['/financeiro', 'controle-fiscal'],
    details: (id: RouteId) => ['/financeiro', 'controle-fiscal', String(id), 'detalhes'],
  },
  refunds: {
    list: () => ['/financeiro', 'reembolsos'],
  },
  revenueGoals: {
    list: () => ['/financeiro', 'metas-de-faturamento'],
  },
  fundsTransfers: {
    list: (id: RouteId) => ['/financeiro', 'repasses', String(id)],
  },
  transfers: {
    list: () => ['/financeiro', 'controle-de-repasses'],
    new: () => ['/financeiro', 'controle-de-repasses', 'novo'],
    edit: (id: RouteId) => ['/financeiro', 'controle-de-repasses', String(id), 'editar'],
  },
  advances: {
    list: () => ['/financeiro', 'gestao-de-adiantamentos'],
    new: () => ['/financeiro', 'gestao-de-adiantamentos', 'novo'],
    edit: (id: RouteId) => ['/financeiro', 'gestao-de-adiantamentos', String(id), 'editar'],
  },
  transactions: {
    list: () => ['/financeiro', 'transacoes'],
  },
  ownerlessTransactions: {
    list: () => ['/financeiro', 'nao-conciliadas'],
  },
  financialDashboard: {
    home: () => ['/financeiro', 'dashboard'],
  },
  ticketSalePoints: {
    list: () => ['/bilheteria', 'pdvs'],
    details: (id: RouteId) => ['/bilheteria', 'pdvs', String(id)],
    participants: (id: RouteId, eventId: RouteId) => ['/bilheteria', 'tipos-de-participante', String(id), String(eventId)],
    dashboard: (id: RouteId) => ['/bilheteria', 'dashboard', String(id)],
  },
  rentals: {
    list: () => ['/inventario', 'aluguel-de-dispositivos'],
    inconsistent: () => ['/inventario', 'alugueis-inconsistentes'],
  },
  physicalDevices: {
    list: () => ['/inventario', 'dispositivos-fisicos'],
    new: () => ['/inventario', 'dispositivos-fisicos', 'novo'],
    edit: (id: RouteId) => ['/inventario', 'dispositivos-fisicos', String(id), 'editar'],
  },
  inventoryDashboard: {
    home: () => ['/inventario', 'dashboard'],
  },
  auth: { callback: () => ['/auth', 'callback'] },
  publicRegistration: (id: RouteId) => ['/cadastro-publico', String(id)],
  forbidden: () => ['/acesso-negado'],
  development: () => ['/dev'],
  developmentTables: () => ['/dev', 'tables'],
  developmentComponents: () => ['/dev', 'components']
};
